<template>
  <TeaserAccountTile
    :title="$t('activationExpiredPage.title')"
    :text="$t('activationExpiredPage.text')"
    :primaryButtonText="$t('activationExpiredPage.primaryButtonText')"
    :primaryButtonLink="url"
    :primaryButtonColor="ButtonColor.PRIMARY"
    :secondary-button-text="$t('activationExpiredPage.secondaryButtonText')"
    :secondaryButtonLink="loginUrl"
  ></TeaserAccountTile>
</template>

<script setup lang="ts">
import TeaserAccountTile from '@/components/rahmen/TeaserAccountTile.vue'
import { ButtonColor } from 'de-zurich-ui-library'

const url: string = globalThis.ENV_CONFIG?.REDIRECTS.ACCOUNT_REGISTRATION_PAGE || ''
const loginUrl: string = globalThis.ENV_CONFIG?.REDIRECTS.LOGIN_PAGE || ''
</script>
